import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPinOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", { d: "M3.446 1a.5.5 0 0 1 .5-.5H8a1.5 1.5 0 0 1 0 3v1.17a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5H8a.5.5 0 0 0 0-1H3.946a.5.5 0 0 1-.5-.5ZM.647.647a.5.5 0 0 1 .707 0l10 10a.5.5 0 1 1-.707.707L8.293 9H6.5v2a.5.5 0 1 1-1 0V9h-3a.5.5 0 0 1-.5-.5v-.88a1.5 1.5 0 0 1 .831-1.342l.892-.45A.5.5 0 0 0 4 5.38v-.673L.647 1.354a.5.5 0 0 1 0-.707Zm3.522 6.075a1.5 1.5 0 0 0 .801-1.045L7.293 8H3v-.38a.5.5 0 0 1 .278-.447l.891-.451Z" }, null, -1), h = [
  f
], p = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  m
];
function g(e, I, n, H, b, t) {
  return r(), l("svg", {
    "aria-label": n.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--pin-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Pin Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, p)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", g]]);
export {
  w as default
};
//# sourceMappingURL=pin-off.js.map
